import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEllipsisVertical,
    faTrash,
    faCopy as faCopySolid,
} from '@fortawesome/free-solid-svg-icons';
import { faCopy as faCopyRegular } from '@fortawesome/free-regular-svg-icons';
import { Protect } from '@clerk/clerk-react';

interface EllipsisOptionsProps {
    onDelete: () => void;
}

const EllipsisOptions: React.FC<EllipsisOptionsProps> = ({ onDelete }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [justCopied, setJustCopied] = useState(false);
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                modalRef.current &&
                !modalRef.current.contains(event.target as Node)
            ) {
                setIsModalVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () =>
            document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleModal = () => setIsModalVisible(!isModalVisible);

    const handleCopyLink = () => {
        // Get the current URL
        const currentUrl = window.location.href;

        // Copy to clipboard
        navigator.clipboard
            .writeText(currentUrl)
            .then(() => {
                // Change icon to solid
                setJustCopied(true);

                // Reset icon after 10 seconds
                setTimeout(() => {
                    setJustCopied(false);
                }, 10000);
            })
            .catch((err) => {
                console.error('Failed to copy: ', err);
            });
    };

    return (
        <div className="ellipsis-options-container" ref={modalRef}>
            <button className="ellipsis-button" onClick={toggleModal}>
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>

            {isModalVisible && (
                <div className="options-modal">
                    <div className="options-modal-content">
                        <Protect permission="org:asset:delete">
                            <button
                                className="modal-button"
                                onClick={() => {
                                    onDelete();
                                    toggleModal();
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} /> Delete Visual
                            </button>
                            <hr />
                        </Protect>
                        <button
                            className="modal-button"
                            onClick={handleCopyLink}
                        >
                            <FontAwesomeIcon
                                icon={justCopied ? faCopySolid : faCopyRegular}
                            />
                            {justCopied ? 'Copied' : 'Copy Link'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EllipsisOptions;
